// Visual only. `spray.strength` below 1 is a part that came off, away from the
// heart; `spray.along` ({x, y, length}) lets a spray start anywhere along a cut.
export const startSpray = spray => {
	const strength = spray.strength ?? 1;
	spray.time *= (0.7 + Math.random() * 0.3) * (strength < 1 ? 0.6 : 1);
	spray.pulse = {
		elapsed: 0,
		total: spray.time / 1000,
		period: 0.42 + Math.random() * 0.3,
		phase: Math.random(),
		beat: -1,
		kick: 1,
		jitter: 0,
		aim: (Math.random() * 2 - 1) * 16,
		wobble: 2 + Math.random() * 3,
		strength,
	};
	if (spray.along) {
		const shift = (Math.random() - 0.5) * spray.along.length * 0.6;
		spray.anchor = {x: spray.anchor.x + spray.along.x * shift, y: spray.anchor.y + spray.along.y * shift};
	}
};

const baseOf = emitter => emitter.sprayBase || (emitter.sprayBase = {
	speedStart: emitter.speedStart, frequency: emitter.frequency,
	minStartRotation: emitter.minStartRotation, maxStartRotation: emitter.maxStartRotation,
});

// Returns the aim offset in degrees.
export const pulseSpray = (spray, emitter, deltaMs) => {
	const pulse = spray.pulse;
	if (!pulse.emitter) {
		pulse.emitter = emitter;
		emitter.sprayOwner = spray;
		// Ending after the emitter has gone back to the pool would steer someone else's.
		const life = emitter.emitterLifetime * 1000 - 50;
		if (life > 0 && spray.time > life) {
			spray.time = life;
			pulse.total = life / 1000;
		}
	}
	if (emitter.sprayOwner !== spray) return 0;
	const base = baseOf(emitter);
	pulse.elapsed += deltaMs / 1000;
	const cycle = pulse.elapsed / pulse.period + pulse.phase;
	const beat = Math.floor(cycle);
	if (beat !== pulse.beat) {
		pulse.beat = beat;
		pulse.kick = 0.7 + Math.random() * 0.55;
		pulse.jitter = (Math.random() * 2 - 1) * 9;
	}
	const surge = Math.max(0.1, Math.pow(1 - (cycle - beat), 2.5));
	const pressure = Math.max(0.25, 1 - 0.65 * Math.pow(pulse.elapsed / pulse.total, 1.6)) * pulse.strength;
	const force = surge * pulse.kick * pressure;
	emitter.speedStart = base.speedStart * (0.35 + 0.85 * force);
	emitter.frequency = Math.min(0.03, base.frequency / Math.max(0.12, force));
	const spread = base.maxStartRotation * (1 + (1 - surge) * 1.4);
	emitter.minStartRotation = -spread;
	emitter.maxStartRotation = spread;
	return pulse.aim + pulse.jitter + Math.sin(pulse.elapsed * pulse.wobble * Math.PI * 2) * 5;
};

export const endSpray = spray => {
	const emitter = spray.emitter;
	if (!emitter || emitter.sprayOwner !== spray) return;
	emitter.sprayOwner = null;
	Object.assign(emitter, baseOf(emitter));
	emitter.emit = false;
};
